"use client";

import React from "react";
import { Plane, Shield, Clock, Activity, Globe } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
const hubs = [{
  id: "jc-east",
  name: "Johns Creek East",
  x: 45,
  y: 40,
  freq: "2,542 Households",
  avail: "98% Delivery Rate",
  type: "primary",
  region: "Active Zone"
}, {
  id: "jc-west",
  name: "Johns Creek West",
  x: 38,
  y: 45,
  freq: "2,480 Households",
  avail: "99% Delivery Rate",
  type: "primary",
  region: "Active Zone"
}, {
  id: "alpharetta",
  name: "Alpharetta Central",
  x: 30,
  y: 35,
  freq: "Coming Soon",
  avail: "Waitlist Open",
  type: "secondary",
  region: "Expansion"
}, {
  id: "milton",
  name: "Milton Estates",
  x: 25,
  y: 25,
  freq: "Coming Soon",
  avail: "Waitlist Open",
  type: "secondary",
  region: "Expansion"
}, {
  id: "roswell",
  name: "Roswell North",
  x: 32,
  y: 55,
  freq: "Coming Soon",
  avail: "Waitlist Open",
  type: "secondary",
  region: "Expansion"
}, {
  id: "duluth",
  name: "Duluth Heights",
  x: 55,
  y: 50,
  freq: "Coming Soon",
  avail: "Waitlist Open",
  type: "secondary",
  region: "Expansion"
}];
const connections = ["M 450 200 Q 415 212 380 225", "M 380 225 Q 340 200 300 175", "M 300 175 Q 275 150 250 125", "M 380 225 Q 350 250 320 275", "M 450 200 Q 500 225 550 250", "M 300 175 Q 310 162 320 150", "M 450 200 Q 400 150 300 175"];
export default function GlobalReach() {
  return <section data-section-id="243425" id="johns-creek-beyond" className="dark bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80%] h-[80%] bg-primary/10 rounded-full blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className="max-w-3xl mx-auto text-center mb-16 sm:mb-24">
          <Badge variant="outline" className="mb-6 border-primary/30 text-primary bg-primary/10 backdrop-blur-sm">
            <Globe className="w-3 h-3 mr-2" />
            Local Coverage
          </Badge>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-default font-bold tracking-tight mb-6">
            Johns Creek & <br className="hidden sm:block" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/70">
              Metro Atlanta Reach.
            </span>
          </h2>
          <p className="text-muted-foreground text-lg sm:text-xl max-w-2xl mx-auto font-default">
            We target high-income households in Metro Atlanta's most prestigious neighborhoods, ensuring your brand lands directly in the hands of qualified local customers.
          </p>
        </div>

        {}
        <div className="relative w-full aspect-[4/3] sm:aspect-[16/9] lg:aspect-[2/1] bg-card/40 rounded-3xl border border-border/50 overflow-hidden shadow-4xl backdrop-blur-md">
          
          {}
          <div className="absolute inset-0 opacity-[0.05] pointer-events-none" style={{
          backgroundImage: `linear-gradient(to right, var(--color-primary) 1px, transparent 1px), linear-gradient(to bottom, var(--color-primary) 1px, transparent 1px)`,
          backgroundSize: '60px 60px'
        }} />

          {}
          <svg viewBox="0 0 1000 500" className="absolute inset-0 w-full h-full pointer-events-none" preserveAspectRatio="none">
            <defs>
              <filter id="glow" x="-20%" y="-20%" width="140%" height="140%">
                <feGaussianBlur stdDeviation="4" result="blur" />
                <feComposite in="SourceGraphic" in2="blur" operator="over" />
              </filter>
              <linearGradient id="line-gradient" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor="var(--color-primary)" stopOpacity="0.1" />
                <stop offset="50%" stopColor="var(--color-primary)" stopOpacity="0.6" />
                <stop offset="100%" stopColor="var(--color-primary)" stopOpacity="0.1" />
              </linearGradient>
            </defs>

            {}
            {connections.map((path, i) => <g key={`conn-${i}`} data-index={i}>
                {}
                <path d={path} fill="none" stroke="var(--color-primary)" strokeWidth="2" strokeOpacity="0.2" filter="url(#glow)" className="animate-pulse" style={{
              animationDuration: `${4 + i}s`
            }} />
                {}
                <path d={path} fill="none" stroke="url(#line-gradient)" strokeWidth="1" strokeDasharray="4 8" className="opacity-60" />
              </g>)}
          </svg>

          {}
          <TooltipProvider delayDuration={100}>
            {hubs.map((hub, i) => <div key={hub.id} data-index={i} className="absolute transform -translate-x-1/2 -translate-y-1/2 z-20" style={{
            left: `${hub.x}%`,
            top: `${hub.y}%`
          }}>
                <Tooltip>
                  <TooltipTrigger asChild>
                    <button className="relative group p-2 outline-none focus-visible:ring-2 focus-visible:ring-primary rounded-full">
                      {}
                      <span className="absolute inset-0 rounded-full bg-primary/20 animate-ping opacity-75" style={{
                    animationDuration: '4s'
                  }}></span>
                      {}
                      <span className={`relative block rounded-full shadow-[0_0_15px_var(--color-primary)] transition-transform duration-500 group-hover:scale-150 ${hub.type === 'primary' ? 'w-4 h-4 bg-primary' : 'w-3 h-3 bg-primary/40 border border-primary/50'}`}></span>
                    </button>
                  </TooltipTrigger>
                  <TooltipContent side="top" className="bg-card/95 backdrop-blur-2xl border border-border/50 p-0 shadow-4xl rounded-xl overflow-hidden w-64" sideOffset={10}>
                    <div className="p-4 border-b border-border/50 bg-muted/50">
                      <div className="flex items-center justify-between mb-1">
                        <span className="text-[10px] font-mono text-muted-foreground uppercase tracking-widest">{hub.region}</span>
                        <Badge variant={hub.type === 'primary' ? 'default' : 'secondary'} className="text-[9px] h-4 px-1.5 font-default">
                          {hub.type === 'primary' ? 'Active Now' : 'Coming Soon'}
                        </Badge>
                      </div>
                      <h4 className="font-default font-bold text-base text-foreground">{hub.name}</h4>
                    </div>
                    <div className="p-4 space-y-3 bg-card">
                      <div className="flex items-center gap-3 text-sm">
                        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                          <Globe className="w-4 h-4 text-primary" />
                        </div>
                        <div>
                          <p className="text-[10px] text-muted-foreground font-default uppercase tracking-tight">Target Volume</p>
                          <p className="font-mono font-semibold text-foreground">{hub.freq}</p>
                        </div>
                      </div>
                      <div className="flex items-center gap-3 text-sm">
                        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                          <Activity className="w-4 h-4 text-primary" />
                        </div>
                        <div>
                          <p className="text-[10px] text-muted-foreground font-default uppercase tracking-tight">Route Status</p>
                          <p className="font-mono font-semibold text-foreground">{hub.avail}</p>
                        </div>
                      </div>
                    </div>
                  </TooltipContent>
                </Tooltip>
              </div>)}
          </TooltipProvider>

          {}
          <div className="absolute bottom-4 left-4 sm:bottom-6 sm:left-6 z-10 flex flex-col sm:flex-row gap-2 sm:gap-4 bg-background/90 backdrop-blur-xl p-3 sm:p-4 rounded-lg border border-border/50 shadow-xl">
            <div className="flex items-center gap-2">
              <span className="w-3 h-3 rounded-full bg-primary shadow-[0_0_10px_var(--color-primary)]"></span>
              <span className="text-xs font-default font-medium text-foreground">Active Routes</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full bg-primary/40 border border-primary/60"></span>
              <span className="text-xs font-default text-muted-foreground">Future Expansion</span>
            </div>
            <div className="flex items-center gap-2">
              <svg width="24" height="4" className="opacity-50">
                <line x1="0" y1="2" x2="24" y2="2" stroke="var(--color-primary)" strokeWidth="1.5" strokeDasharray="3 3" />
              </svg>
              <span className="text-xs font-default text-muted-foreground">EDDM Logistics</span>
            </div>
          </div>
        </div>

        {}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12 sm:mt-16">
          {[{
          icon: Clock,
          title: "Precision Timing",
          desc: "Coordinated USPS EDDM drops for maximum neighborhood impact."
        }, {
          icon: Shield,
          title: "Category Exclusive",
          desc: "One business per category. No competitors on your postcard."
        }, {
          icon: Plane,
          title: "Direct Delivery",
          desc: "Premium oversized postcards delivered straight to the mailbox."
        }].map((feature, i) => <div key={i} data-index={i} className="flex flex-col items-center text-center p-8 rounded-2xl bg-card/20 border border-border/20 backdrop-blur-md shadow-sm hover:shadow-md transition-shadow duration-300">
              <div className="w-14 h-14 rounded-xl bg-primary/10 flex items-center justify-center mb-5">
                <feature.icon className="w-7 h-7 text-primary" />
              </div>
              <h3 className="font-default font-bold text-foreground text-lg mb-3">{feature.title}</h3>
              <p className="text-sm text-muted-foreground font-default leading-relaxed">{feature.desc}</p>
            </div>)}
        </div>
      </div>
    </section>;
}